import { useMemo, useState } from 'react';
import FallbackImage from './FallbackImage';
import Navigation from './Navigation';
import PhotoModal from './PhotoModal';
import { getAllPhotos, places } from './travelData';

function Gallery({ navigate, pathname }) {
  const [selectedPlaces, setSelectedPlaces] = useState([]);
  const [selectedPhoto, setSelectedPhoto] = useState(null);
  const allPhotos = useMemo(() => getAllPhotos(), []);

  const activePhotos = selectedPlaces.length
    ? allPhotos.filter((photo) => selectedPlaces.includes(photo.placeId))
    : allPhotos;

  const togglePlace = (placeId) => {
    setSelectedPlaces((current) =>
      current.includes(placeId)
        ? current.filter((id) => id !== placeId)
        : [...current, placeId]
    );
  };

  const openPhotoOnMap = (photoId) => {
    setSelectedPhoto(null);
    navigate(`/map?loc=${photoId}`);
  };

  const openPhoto = (photo) => {
    setSelectedPhoto(photo);
  };

  return (
    <main className="gallery-page">
      <Navigation navigate={navigate} pathname={pathname} />

      <section className="gallery-toolbar" aria-label="Place filters">
        <button
          className={selectedPlaces.length === 0 ? 'filter-chip active' : 'filter-chip'}
          type="button"
          onClick={() => setSelectedPlaces([])}
        >
          All places
        </button>
        {places.map((place) => (
          <button
            className={selectedPlaces.includes(place.id) ? 'filter-chip active' : 'filter-chip'}
            key={place.id}
            type="button"
            onClick={() => togglePlace(place.id)}
          >
            {place.name}
          </button>
        ))}
      </section>

      <section className="masonry-gallery" aria-label="Travel photos">
        {activePhotos.map((photo) => (
          <article
            className={`gallery-card ${photo.aspect || 'wide'}`}
            key={photo.id}
          >
            <button
              className="gallery-card-main"
              type="button"
              onClick={() => openPhoto(photo)}
            >
              <FallbackImage
                src={photo.thumbnail || photo.src}
                alt={photo.title}
                label={photo.placeName}
                aspect={photo.aspect}
              />
            </button>
            <div className="gallery-card-actions">
              <div className="gallery-card-meta">
                <b>{photo.placeName}</b>
                <span>{photo.title}</span>
              </div>
              <div className="gallery-card-buttons">
                <button
                  className="gallery-card-action"
                  type="button"
                  onClick={(event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    openPhoto(photo);
                  }}
                >
                  View image
                </button>
                <button
                  className="gallery-card-action"
                  type="button"
                  onClick={(event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    openPhotoOnMap(photo.id);
                  }}
                >
                  View location
                </button>
              </div>
            </div>
          </article>
        ))}
      </section>
      <PhotoModal photo={selectedPhoto} onClose={() => setSelectedPhoto(null)} />
    </main>
  );
}

export default Gallery;
